import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Rotas } from 'src/app/core/rotas';
import { MatriculaSecretaria } from '../../core/matricula-secretaria';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class MatriculaSecretariaService extends BaseService<MatriculaSecretaria> {

  

  constructor(http: HttpClient) {
    super(http, Rotas.MATRICULA_SECRETARIA);
  }


  getAllBy(idUnidade?: number, beneficiario?: string) {
    let params = new HttpParams();

    if (idUnidade != null) {
      params = params.set('idUnidade', idUnidade.toString());
    }

    if (beneficiario != null && beneficiario !== '') {
      params = params.set('beneficiario', beneficiario);
    }

    return this.http.get<MatriculaSecretaria[]>(this.rota, { params });
  }
}
